export const SET_TOKEN = "SET_TOKEN";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const UNSET_CURRENT_USER = "UNSET_CURRENT_USER";
export const SET_LOGIN_ERROR_MSG = "SET_LOGIN_ERROR_MSG";
export const CLEAR_LOGIN_ERRORS = "CLEAR_LOGIN_ERRORS";
